import { introAssets } from '../constants/assets';

export const publicPanels = [
  {
    title: '승마장 찾기',
    body: '가까운 승마장과 프로그램 정보를 확인하고 나에게 맞는 기승을 찾아보세요.',
  },
  {
    title: '간편 예약',
    body: '전화 문의 없이 날짜, 시간, 인원을 선택해 승마 예약 흐름을 이어갑니다.',
  },
  {
    title: '파트너스',
    body: '승마장 운영과 홍보, 신규회원 모집에 필요한 관리 도구를 함께 제공합니다.',
  },
];

export const serviceItems = [
  {
    title: '승마 예약',
    body: '프로그램, 가격, 예약 가능 시간을 확인하고 원하는 일정으로 기승을 신청합니다.',
  },
  {
    title: '강습 내역',
    body: '수업 이력과 피드백을 모아 승마 경험이 이어지도록 관리합니다.',
  },
  {
    title: '승마장 관리',
    body: '회원, 마필, 마장, 쿠폰과 스케줄을 PC와 모바일에서 함께 관리합니다.',
  },
  {
    title: '고객 지원',
    body: '서비스 문의와 파트너 상담을 공식 채널에서 빠르게 연결합니다.',
  },
];

export const newsItems = [
  {
    category: '공지',
    title: '말타 서비스 업데이트',
    body: '앱과 공식 웹의 새로운 기능, 예약 흐름 개선 소식을 전합니다.',
  },
  {
    category: '파트너',
    title: '승마장 파트너 소식',
    body: '말타 파트너스 운영, 프로모션, 이벤트 관련 소식을 모아봅니다.',
  },
  {
    category: '콘텐츠',
    title: '승마를 더 쉽게 시작하는 방법',
    body: '승마체험, 강습 준비, 말과 가까워지는 이야기를 말타뉴스에서 소개합니다.',
  },
];

export const partnerPageFeatures = [
  {
    title: '회원과 예약 관리',
    body: '신규회원 모집부터 기승 예약, 스케줄 공유까지 운영 흐름을 한 곳에서 봅니다.',
  },
  {
    title: '마필·마장 관리',
    body: '마필 상태와 마장 운영 정보를 기록해 현장 관리의 빈틈을 줄입니다.',
  },
  {
    title: '쿠폰과 프로모션',
    body: '자동 쿠폰관리와 홍보 기능으로 재방문과 신규 유입을 함께 설계합니다.',
  },
];

export const supportItems = [
  {
    title: '전화 문의',
    body: '02-567-0543',
    href: 'tel:025670543',
  },
  {
    title: '이메일 문의',
    body: 'help@luxspo.com',
    href: 'mailto:help@luxspo.com',
  },
  {
    title: '파트너 상담',
    body: '승마장 입점과 관리 서비스 도입 문의를 남겨주세요.',
    href: '#/partners',
  },
];

export const socialLinks = [
  {
    label: '블로그',
    href: process.env.REACT_APP_MARLTA_BLOG_URL || 'https://blog.naver.com/luxspo',
    icon: introAssets.blogIcon,
  },
  {
    label: '유튜브',
    href:
      process.env.REACT_APP_MARLTA_YOUTUBE_URL ||
      'https://www.youtube.com/channel/UCFfyX9Q7Gt1ZwHdNY8ZAY5w',
    icon: introAssets.youtubeIcon,
  },
  {
    label: '인스타그램',
    href: process.env.REACT_APP_MARLTA_INSTAGRAM_URL || 'https://www.instagram.com/malta_luxspo/',
    icon: introAssets.instagramIcon,
  },
  {
    label: '페이스북',
    href: process.env.REACT_APP_MARLTA_FACEBOOK_URL || 'https://www.facebook.com/malta.luxspo',
    icon: introAssets.facebookIcon,
  },
];

export const introHighlights = [
  { value: '01', label: '내 주변 승마장을 찾고' },
  { value: '02', label: '프로그램과 가격을 비교하고' },
  { value: '03', label: '원하는 시간에 바로 예약' },
];

export const riderFeatures = [
  {
    title: '가까운 승마장 추천',
    body: '위치와 프로그램 정보를 바탕으로 지금 가기 좋은 승마장을 빠르게 찾습니다.',
  },
  {
    title: '프로그램 가격 확인',
    body: '체험, 강습, 정기 프로그램의 가격과 예약 가능 시간을 한 화면에서 확인합니다.',
  },
  {
    title: '예약과 강습 기록',
    body: '기승 일정, 강습 내역, 피드백을 앱에서 자연스럽게 이어갑니다.',
  },
];

export const partnerFeatures = [
  '신규회원 모집',
  '스케줄 공유',
  '자동 쿠폰관리',
  'PC와 모바일 관리',
  '학생승마 예약/관리',
];

export const introSignals = ['승마장 정보', '프로그램 가격', '예약 가능 시간', '강습 내역'];

export const introStats = [
  { value: '탐색', label: '승마장과 프로그램' },
  { value: '예약', label: '날짜·시간 선택' },
  { value: '기록', label: '강습 내역 관리' },
];

export const introNavigatorItems = [
  { id: 'intro-home', label: '말타' },
  { id: 'intro-booking', label: '예약흐름' },
  { id: 'intro-network', label: '전국승마장' },
  { id: 'intro-app', label: '앱 소개' },
  { id: 'intro-partners', label: '파트너스' },
  { id: 'intro-news', label: '말타뉴스' },
  { id: 'intro-download', label: '시작하기' },
];

export const institutionLogos = [
  {
    label: '경기창조경제혁신센터',
    image: introAssets.institutionGyeonggi,
  },
  {
    label: '중소벤처기업부',
    image: introAssets.institutionMinistry,
  },
  {
    label: '한국마사회',
    image: introAssets.institutionKra,
  },
  {
    label: 'KSEF',
    image: introAssets.institutionKsef,
  },
  {
    label: '대한재활승마협회',
    image: introAssets.institutionTherapeuticHorsemanship,
  },
  {
    label: '한국관광공사',
    image: introAssets.institutionKto,
  },
  {
    label: '농림축산식품부',
    image: introAssets.institutionMafra,
  },
];
